export const DAY_NAMES = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

export function getWeekStart(d = new Date()) {
  const date = new Date(d);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function weekKey(d = new Date()) {
  const ws = getWeekStart(d);
  const jan1 = new Date(ws.getFullYear(), 0, 1);
  const wn = Math.ceil(((ws - jan1) / 86400000 + jan1.getDay() + 1) / 7);
  return `${ws.getFullYear()}-W${String(wn).padStart(2, '0')}`;
}

export function getDayDates(ws) {
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(ws);
    d.setDate(d.getDate() + i);
    return d;
  });
}

export function addWeeks(date, count) {
  const next = new Date(date);
  next.setDate(next.getDate() + count * 7);
  next.setHours(0, 0, 0, 0);
  return next;
}

export function formatDate(d) {
  return new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}

export function uid() {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function makeTask(overrides = {}) {
  return {
    id: uid(),
    type: 'task',
    text: '',
    done: false,
    hours: 0,
    subtasks: [],
    comment: '',
    showComment: false,
    expanded: false,
    ...overrides,
  };
}

export function makeTag(overrides = {}) {
  return {
    id: uid(),
    type: 'tag',
    text: 'New section',
    ...overrides,
  };
}

export function makeWeekData(weekStart) {
  const days = {};
  const dates = getDayDates(weekStart);
  DAY_NAMES.forEach((name, i) => {
    days[name] = {
      date: dates[i].toISOString(),
      tasks: Array.from({ length: 15 }, () => makeTask()),
    };
  });
  return { weekStart: weekStart.toISOString(), days };
}

export function findTaskById(tasks, id) {
  for (const t of tasks) {
    if (t.id === id) return t;
    const found = findTaskById(t.subtasks || [], id);
    if (found) return found;
  }
  return null;
}

export function countTasks(tasks) {
  let done = 0, total = 0;
  tasks.forEach(t => {
    if (t.type === 'tag') return;
    if (t.text) {
      total++;
      if (t.done) done++;
    }
  });
  return { done, total };
}
